import { render } from "./AposColorAlpha.vue?vue&type=template&id=35226486&scoped=true"
import script from "./AposColorAlpha.vue?vue&type=script&lang=js"
export * from "./AposColorAlpha.vue?vue&type=script&lang=js"

import "./AposColorAlpha.vue?vue&type=style&index=0&id=35226486&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35226486"],['__file',"color-field/ui/apos/lib/AposColorAlpha.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "35226486"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('35226486', __exports__)) {
    api.reload('35226486', __exports__)
  }
  
  module.hot.accept("./AposColorAlpha.vue?vue&type=template&id=35226486&scoped=true", () => {
    api.rerender('35226486', render)
  })

}


export default __exports__